<template>
  <div>
    <h1 class="title mqu-subtitle">About You</h1>
    <h2 class="subtitle">Tell us some basic information about yourself. This helps us to estimate how long you may stay in the village.</h2>
    <age v-model="data.age" v-on:input="update"/>
    <gender v-model="data.gender" v-on:input="update"/>
    <is-couple v-model="data.isCouple" v-on:input="update"/>
    <transition name="fade" mode="out-in">
      <keep-alive>
        <partner-age v-model="data.partnerAge" v-if="data.isCouple" v-on:input="update"/>
      </keep-alive>
    </transition>
    <transition name="fade" mode="out-in">
      <keep-alive>
        <partner-gender v-model="data.partnerGender" v-if="data.isCouple" v-on:input="update"/>
      </keep-alive>
    </transition>
  </div>
</template>

<script>
import IsCouple from '../inputs/basic-information/IsCouple'
import Age from '../inputs/basic-information/Age'
import PartnerAge from '../inputs/basic-information/PartnerAge'
import Gender from '../inputs/basic-information/Gender'
import PartnerGender from '../inputs/basic-information/PartnerGender'

export default {
  props: ['value'],
  inject: ['$validator'],
  components: {
    PartnerGender,
    Gender,
    PartnerAge,
    Age,
    IsCouple
  },
  data() {
    return {
      data: {
        isCouple: this.value.isCouple,
        age: this.value.age,
        gender: this.value.gender,
        partnerAge: this.value.partnerAge,
        partnerGender: this.value.partnerGender
      }
    }
  },
  methods: {
    update: function() {
      this.$emit('input', this.data)
    }
  }
}
</script>

<style scoped>
.mqu-title {
  font-family: 'National-Extrabold';
}

.mqu-subtitle {
  font-family: 'National-Light';
}
</style>



// WEBPACK FOOTER //
// src/components/modules/stages/BasicInformation.vue